import { type FC } from 'react';
import FLabel from '../FLabel/FLabel';
import NumericInput, {
  type NumericInputProps,
} from '@components/inputs/NumericInput/NumericInput';
import { Controller, useFormContext } from 'react-hook-form';
import { type InputAddormentProps } from '@components/inputs/InputAddornment/InputAddorment';

export interface ControlledNumericInputProps
  extends InputAddormentProps,
    NumericInputProps {}
export interface FNumericFieldProps extends ControlledNumericInputProps {
  label?: string;
}

const FNumericField: FC<FNumericFieldProps> = ({
  label,
  name,
  id,
  ...props
}: FNumericFieldProps) => {
  const { control } = useFormContext();

  return (
    <div className="flex flex-1 flex-col gap-2">
      {label && <FLabel id={id}>{label}</FLabel>}
      <Controller
        name={name ?? 'unknown'}
        control={control}
        render={({ field, fieldState: { error } }) => {
          return (
            <NumericInput
              id={id}
              data-testid={`${name ?? 'unknown'}-field`}
              error={error}
              {...field}
              {...props}
            />
          );
        }}
      />
    </div>
  );
};
export default FNumericField;
